import {
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import RadiationCleanupDescription from '../../../../components/FormDescriptions/RadiationCleanupDescription';
import { FULL_SCHEMA } from '../../../../utils/imports';
import content from '../../../../locales/en/content.json';

const TITLE_TEXT = content['service-info--radiation-title'];
const INPUT_LABEL = content['service-info--radiation-label'];
const ARIA_DESC_TEXT = content['service-info--radiation-aria-label'];

const { radiationCleanupEfforts } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    radiationCleanupEfforts: yesNoUI({
      title: INPUT_LABEL,
      description: RadiationCleanupDescription,
      headerAriaDescribedby: ARIA_DESC_TEXT,
    }),
  },
  schema: {
    type: 'object',
    properties: { radiationCleanupEfforts },
  },
};
